import { v1 as uuidv1 } from 'uuid'
import { encryptText } from '@/../../shared/src/utils/encryption.js'
import { minuteInMs } from '@/../../shared/src/utils/time.js'
import { socketUrl } from './constants.js'
import { storageKey } from '@/../../shared/src/store/plugins/localStorage'
import { getFromLocalStorage } from '@/../../shared/src/store/plugins/localStorage'
import { delayCall } from '@/../../shared/src/utils.js'

let heartbeat = null

export function openSocketConnection (appName, classId, userId, messageHandler, openHandler, closeHandler, firstConnection) {

  const requestId = uuidv1()
  const securityToken = encodeURIComponent(encryptText(requestId))
  const fullSocketUrl = `${socketUrl}?channel=${appName}-${classId}&username=${userId}&securityToken=${securityToken}&requestId=${requestId}&firstConnection=${firstConnection}`
  const connection = new WebSocket(fullSocketUrl)

  connection.removeEventListener('open', openHandler)
  connection.removeEventListener('close', closeHandler)
  connection.removeEventListener('message', messageHandler)

  connection.addEventListener('open', openHandler)
  connection.addEventListener('close', closeHandler)
  connection.addEventListener('message', messageHandler)

  window.clearInterval(heartbeat)
  heartbeat = window.setInterval(() => {
    return sendSocketHeartbeat(connection, userId)
  }, minuteInMs * 6)

  return connection

}

function sendSocketHeartbeat (connection, userId) {
  const message = {'action': 'onMessage', 'messagePayload': {'sender': userId, 'heartbeat': {}}}
  return connection.send(JSON.stringify(message))
}

export function getUserId (store) {
  const classIdOverride = store.state.config.classroom.event.breakout_parent
  const guestUser = getFromLocalStorage(storageKey(`guest-user`, classIdOverride))
  return guestUser ? guestUser.id : store.state.config.user.id
}

export function formatSocketMessageArray (mutation, payload, senderId, opts) {
  const payloadString = JSON.stringify(payload)
  const payloadChannel = payload && payload.broadcastChannel
  const payloadArray = payload ? payloadString.match(/.{1,10000}/g) : []
  const liveTextEdit = (mutation === 'whiteboard/crudAnnotations' && payload.object && !!(payload.object.activeEditMode))
  const msgId = `${senderId}-${mutation}-${new Date().toISOString()}`

  if (payloadArray.length > 1) {
    console.log(`message array length: ${payloadArray.length}`)
  }

  return payloadArray.map((payloadString, idx) => {
    let msgObj = formatSocketMessage(mutation, payloadString, senderId, payloadChannel)

    msgObj.messagePayload.meta = {
      'totalMsgs': payloadArray.length,
      'msgNumber': idx + 1,
      'id': msgId,
      'store': liveTextEdit ? false : opts.store,
      'broadcast': opts.broadcast,
      'log': opts.log
    }
    return msgObj
  })
}

export function formatSocketMessage (mutation, payload, senderId, channel) {

  const mutationParts = mutation.split('/')
  return {
    'action': 'onMessage',
    'messagePayload': {
      'sender': senderId,
      'payload': payload,
      'name': mutationParts[1],
      'actionMutation': mutation
    }
  }
}

export function sendMessage (connection, msg, reconnect, sendAttempts = 0) {

  try {
    if (connection.readyState === WebSocket.CLOSED && window.navigator.onLine) {
      connection = reconnect()
    }
    connection.send(JSON.stringify(msg))
  } catch (err) {
    if ((err.name === 'InvalidStateError') && (connection.readyState === WebSocket.CONNECTING) && (sendAttempts < 3)) {
      sendAttempts += 1
      delayCall(() => sendMessage(connection, msg, reconnect, sendAttempts), (sendAttempts * 750))
    } else {
      throw err
    }
  }
  return connection
}
